import WebPaymentBtn from './WebPaymentBtn'

export default WebPaymentBtn
